import React from 'react';
import PopoverMUI, { PopoverProps as PopoverMUIProps } from '@mui/material/Popover';

export type PopoverProps = PopoverMUIProps;

export function Popover(props: PopoverProps): JSX.Element {
  return <PopoverMUI {...props} />;
}
